import api, { apiSuccessOutput } from '@/shared/config/api.js';

export const getBillingPlans = async () =>
  apiSuccessOutput(await api.get('/financial/v1/plans', { showToast: false }));

export const getCurrentSubscription = async (tenantId) =>
  apiSuccessOutput(
    await api.get(`/financial/v1/tenants/${tenantId}/subscription`, {
      showToast: false,
    }),
  );

export const getInvoices = async (tenantId) =>
  apiSuccessOutput(
    await api.get(`/financial/v1/tenants/${tenantId}/invoices`, {
      showToast: false,
    }),
  );

export const getPayments = async (tenantId) =>
  apiSuccessOutput(
    await api.get(`/financial/v1/tenants/${tenantId}/payments`, {
      params: { limit: 100 },
      showToast: false,
    }),
  );

export const getCredit = async (tenantId) =>
  apiSuccessOutput(
    await api.get(`/financial/v1/tenants/${tenantId}/credit`, {
      showToast: false,
    }),
  );

export const getCreditTransactions = async (tenantId) =>
  apiSuccessOutput(
    await api.get(`/financial/v1/tenants/${tenantId}/credit/transactions`, {
      params: { limit: 50, include_operational: false },
      showToast: false,
    }),
  );

export const getCreditUsage = async ({ tenantId, days, page, pageSize }) =>
  apiSuccessOutput(
    await api.get(`/financial/v1/tenants/${tenantId}/credit/usage`, {
      params: { days, page, page_size: pageSize },
      showToast: false,
    }),
  );

export const createCheckout = async ({
  tenantId,
  planCode,
  interval,
  deviceAddonPacks,
  idempotencyKey,
}) =>
  apiSuccessOutput(
    await api.post(`/financial/v1/tenants/${tenantId}/checkout`, {
      plan_code: planCode,
      interval,
      device_addon_packs: deviceAddonPacks,
      idempotency_key: idempotencyKey,
    }),
  );

export const createCreditCheckout = async ({
  tenantId,
  amountToman,
  idempotencyKey,
}) =>
  apiSuccessOutput(
    await api.post(`/financial/v1/tenants/${tenantId}/credit/checkout`, {
      amount_toman: amountToman,
      idempotency_key: idempotencyKey,
    }),
  );
